export function latestThrottle(callback, interval = 400, timers = {}) {
  const now = timers.now || Date.now;
  const setTimer = timers.setTimeout || globalThis.setTimeout;
  const clearTimer = timers.clearTimeout || globalThis.clearTimeout;
  let last = -Infinity;
  let timer = null;
  let pending = null;
  const run = () => {
    timer = null;
    if (!pending) return;
    const args = pending;
    pending = null;
    last = now();
    callback(...args);
  };
  return {
    schedule(...args) {
      pending = args;
      const remaining = interval - (now() - last);
      if (remaining <= 0) {
        if (timer !== null) clearTimer(timer);
        run();
      } else if (timer === null) timer = setTimer(run, remaining);
    },
    cancel() {
      if (timer !== null) clearTimer(timer);
      timer = null;
      pending = null;
    },
  };
}
